import VacancyInformation from './VacancyInformation.page';

export default VacancyInformation;
